import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import emailjs from '@emailjs/browser';
import { Bio } from '../../data/constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 40px 0 20px;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
`;

const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};

  @media screen and (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

const ContactForm = styled.form`
  width: 95%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background-color: rgba(17, 25, 40, 0.83);
  border: 1px solid rgba(255, 255, 255, 0.125);
  padding: 32px;
  border-radius: 12px;
  box-shadow: rgba(23, 92, 230, 0.1) 0 4px 24px;
  margin-top: 28px;
  gap: 12px;
`;

const ContactTitle = styled.div`
  font-size: 28px;
  margin-bottom: 6px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
`;

const ContactInput = styled.input`
  flex: 1;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.text_secondary + 50};
  outline: none;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;

  &:focus {
    border: 1px solid ${({ theme }) => theme.text_primary};
  }
`;

const ContactButton = styled.input`
  width: 100%;
  border: none;
  padding: 13px 16px;
  margin-top: 2px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  background-color: hsla(271, 100%, 50%, 1);
  color: #fff;
  text-align: center;
  cursor: pointer;
`;

const ContactInputMessage = styled.textarea`
  flex: 1;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.text_secondary + 50};
  outline: none;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
  border-radius: 12px;
  padding: 12px 16px;
  font-family: inherit;

  &:focus {
    border: 1px solid ${({ theme }) => theme.text_primary};
  }
`;

const DirectEmail = styled.a`
  color: ${({ theme }) => theme.primary};
  text-decoration: none;
  font-weight: 500;
`;

const Status = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.text_secondary};
`;

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('Sending...');
    emailjs
      .sendForm('service_u6cl75b', 'template_0955ovu', form.current, 'cyBM3GUiJdk4KMXEW')
      .then(
        () => {
          setStatus('Message sent. Thank you!');
          form.current.reset();
        },
        () => {
          setStatus(`Could not send the form. Email me at ${Bio.email}`);
        }
      );
  };

  return (
    <Container id="Contact">
      <Wrapper>
        <Title>Contact</Title>
        <Desc style={{ marginBottom: '8px' }}>
          Open to software engineering roles and freelance work.{' '}
          <DirectEmail href={`mailto:${Bio.email}`}>{Bio.email}</DirectEmail>
        </Desc>
        <ContactForm ref={form} onSubmit={handleSubmit}>
          <ContactTitle>Email Me</ContactTitle>
          <ContactInput name="from_email" type="email" placeholder="Your Email" required />
          <ContactInput name="from_name" placeholder="Your Name" required />
          <ContactInput name="subject" placeholder="Subject" required />
          <ContactInputMessage name="message" placeholder="Message" rows={4} required />
          <ContactButton type="submit" value="Send" />
          {status && <Status>{status}</Status>}
        </ContactForm>
      </Wrapper>
    </Container>
  );
};

export default Contact;
